import type {Mapper} from 'framework';
import type {ScheduleTemplateOption} from '../../domain/schedule-template-option';
import type {WorkoutTemplateSummaryDto} from '../dto/schedule.dto';

/** The picker only needs the template's identity and name. */
export class WorkoutTemplateSummaryDtoToScheduleTemplateOptionMapper implements Mapper<
  WorkoutTemplateSummaryDto,
  ScheduleTemplateOption
> {
  transform(dto: WorkoutTemplateSummaryDto): ScheduleTemplateOption {
    return {id: dto.id, name: dto.name};
  }
}
